import {
  Area,
  ComposedChart,
  CartesianGrid,
  Tooltip,
  XAxis,
  ResponsiveContainer,
} from 'recharts';
import { ReactNode } from 'react';
import { formatDateAxis, groupByMonth } from '@/utils/explorer';
import { IAreaGraph } from '@/types/explorer';
import ActiveDot from './ActiveDot';

interface Props {
  data: IAreaGraph[];
  customTooltip: (props: any) => ReactNode;
}

const resetMonths = (data: IAreaGraph[]) => groupByMonth(data.map(d => d.date));

const AreaChart: React.FC<Props> = ({ data, customTooltip }) => {
  let months = resetMonths(data);
  let displayedIdxs: number[] = [];
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} className="mr-8 [&>svg]:overflow-visible">
        <CartesianGrid vertical={false} horizontal={false} opacity={0} />
        <XAxis
          axisLine={false}
          dataKey="date"
          tickLine={false}
          type="category"
          interval={0}
          style={{
            fontSize: '0.625rem',
            textTransform: 'uppercase',
            fill: 'hsl(var(--neutral-0))',
          }}
          allowDuplicatedCategory={false}
          stroke="hsl(var(--azure-400))"
          tickMargin={5}
          tickFormatter={(d: any, idx: number) => {
            // Recharts has this "double" re-render on the tickFormatter
            // which causes a problem to display the grouped months on the initial render
            // so we need to reset the "grouped month displayed" on the 2nd re-render
            if (displayedIdxs.includes(idx)) {
              months = resetMonths(data);
              displayedIdxs = [idx];
            } else {
              displayedIdxs.push(idx);
            }
            return formatDateAxis(d, months);
          }}
        />
        <Tooltip
          filterNull={false}
          cursor={{
            stroke: 'hsl(var(--neutral-0))',
            opacity: 0.4,
          }}
          content={customTooltip}
        />
        <Area
          type="monotone"
          dataKey="value"
          stroke="hsl(var(--azure-400))"
          fill="rgba(145, 188, 253, 0.50)"
          isAnimationActive={false}
          activeDot={<ActiveDot />}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default AreaChart;
